<template>
<div class="chapter">
<div class="inner_page">
<a id="page_3"></a>
<h1 class="title"><span class="bold">THE LIVERPOOL AND MANCHESTER RAILWAY</span></h1>
<p class="titlea"><span class="bold">An Operating History</span></p>
<p class="author"><span class="bold">ANTHONY DAWSON</span></p>
<div class="img_containerpp">
<img alt="images" src="images/f0003-01.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Title.vue?f096e158